import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './checkin-delete-companion-result.actions';
import { CheckinDeleteCompanionResultState } from './checkin-delete-companion-result.state';

/**
 * checkinDeleteCompanionResult initial state
 */
export const checkinDeleteCompanionResultInitialState: CheckinDeleteCompanionResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for CheckinDeleteCompanionResult Store
 */
export const checkinDeleteCompanionResultReducerFeatures: ReducerTypes<
  CheckinDeleteCompanionResultState,
  ActionCreator[]
>[] = [
  on(actions.setCheckinDeleteCompanionResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateCheckinDeleteCompanionResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetCheckinDeleteCompanionResult, () => checkinDeleteCompanionResultInitialState),

  on(actions.cancelCheckinDeleteCompanionResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failCheckinDeleteCompanionResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(
    actions.setCheckinDeleteCompanionResultFromApi,
    actions.updateCheckinDeleteCompanionResultFromApi,
    (state, payload) => asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * CheckinDeleteCompanionResult Store reducer
 */
export const checkinDeleteCompanionResultReducer = createReducer(
  checkinDeleteCompanionResultInitialState,
  ...checkinDeleteCompanionResultReducerFeatures
);
